var map = {
	"./kj1.png": "X2zy",
	"./kj10.png": "SK+/",
	"./kj11.png": "0uRs",
	"./kj12.png": "o6hm",
	"./kj2.png": "0+O6",
	"./kj3.png": "5i9X",
	"./kj4.png": "FEnq",
	"./kj5.png": "mdSY",
	"./kj6.png": "vUP7",
	"./kj7.png": "e0+9",
	"./kj8.png": "9sk5",
	"./kj9.png": "6wyj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9AQq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kuaijie ^\.\/kj.*\.png$
// module id = 9AQq
// module chunks = 1